import PaymentApprovalList from './PaymentApprovalList';

const paymentApprovals = {
	list: PaymentApprovalList
};

export default paymentApprovals;
